import React, { Component } from "react";
import { Container, UnderLine } from "../Common__style/Micro-style";
import * as C from "../Capabilities/Capabilities-style";
import BlueButton from "../BlueButton/BlueButon";
import CapabilitiesItem from "./Capabilities__Item";

export default class Capabilities extends Component {

   render() {

      let options = [
         { img: "Capabilities__1.png", title: "project and construction management" },
         { img: "Capabilities__2.png", title: "structure audit and maintenance" },
         { img: "Capabilities__3.png", title: "factory construction and modeling" }
      ]

      return (
         <C.CapabilitiesBody>
            <Container>
               <C.CapabilitiesHead>
                  <div>
                     <C.CapabilitiesTitle>Our capabilities</C.CapabilitiesTitle>
                     <UnderLine></UnderLine>
                  </div>
                  <C.CapabilitiesText>
                     Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.
                  </C.CapabilitiesText>
                  <div>
                     <BlueButton text={'All services'} />
                  </div>
               </C.CapabilitiesHead>
               <C.CapabilitiesItems>
                  <CapabilitiesItem options={options[0]} />
                  <CapabilitiesItem options={options[1]} />
                  <CapabilitiesItem options={options[2]} />
               </C.CapabilitiesItems>
            </Container>
         </C.CapabilitiesBody>
      )
   }
}